module.exports = __webpack_public_path__ + "7302d51fc149714f55898d23903235e9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-2.png
// module id = 1687
// module chunks = 0